/**
 * JSON helpers over localStorage. Storage can be missing or throw (private mode,
 * blocked site data), so every read falls back and every write is best effort.
 */
export const readStored = (key: string): unknown => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? null : JSON.parse(raw);
  } catch {
    return null;
  }
};

export const writeStored = (key: string, value: unknown): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // the state simply won't survive a reload
  }
};

export const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value);

export const stringOr = (value: unknown, fallback: string): string => (typeof value === 'string' ? value : fallback);

export const numberOr = (value: unknown, fallback: number): number => (typeof value === 'number' && Number.isFinite(value) ? value : fallback);
